module.exports = __webpack_public_path__ + "img/lavalife.e40ffd6.svg";